module.exports = __webpack_public_path__ + "img/part4bg.765d7b3d.png";